import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Player from './player';

/**
 * @class Players
 *
 * @description
 * Class for the Players organisation and data binding.
 *
 * @example
 * <Players />
 */

@connect(
	state => {
		let activeStep = state.step.activeStep && state.setup[state.step.activeStep.ref][state.step.activeStep.id];
		if (activeStep && (activeStep.male || activeStep.female)) {
			activeStep = activeStep.male || activeStep.female;
		}
		return {
			activeStepId: state.step.activeStep.id,
			playerData: state.setup.players,
			activePlayers: activeStep && activeStep.windows[state.currentWindow.index],
			playersResources: state.results.saveState.players,
			isDelayed: state.modal.isModalDelayed,
			isModalClosed: state.modal.isModalClosed,
			countryCode: state.user.profileData.countryCode
		}
	}
)
export default class Players extends Component {

	static PropTypes = {
		playerData: PropTypes.object,
		activePlayers: PropTypes.object,
	};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	buildPlayers () {
		let activePlayers;

		const { isModalClosed, playerData, isDelayed, playersResources, countryCode, activeStepId } = this.props;

		if (this.props.activePlayers && this.props.activePlayers.players) {
			activePlayers = this.props.activePlayers.players;
		}

		const players = Object.entries(playerData).map((data, index) => {
			let isPlayerActive = 'default';

			if (activePlayers && activePlayers.length) {
				isPlayerActive = activePlayers.find((player) => {
					return player === data[0];
				});
			}

			return <Player
				activeStepId={activeStepId}
				isPlayerCharacter={!index}
				key={data[0]}
				{...data[1]}
				isPlayerActive={isPlayerActive}
				delayTransition={isDelayed}
				resources={playersResources[data[0]].resources}
				countryCode={countryCode}
			/>;
		});

		return (
			<div
				className={'players'}
				style={{ zIndex: isModalClosed ? 2 : 0 }}
			>{players}</div>
		);
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		return !!this.props.activePlayers ? this.buildPlayers() : null;
	}
}
